import * as api from "../constant/NewAPI";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Link } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import Utils from "../constant/Utils";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

// import * as api from "../constant/API";

const GroupList = () => {

    const [searchInput, setSearchInput] = useState("");
    const [groupList, setGroupList] = useState([]);
    const [grpName, setGrpName] = useState("");
    const [grpDescription, setGrpDescription] = useState("");
    const [updateGrpId, setUpdateGrpId] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const formRef = useRef(null);

    const roleId = localStorage.getItem("RoleId");
    const userId = localStorage.getItem("UserId");

    const didFetch = useRef(false);

    useEffect(() => {
        if (!didFetch.current) {
            didFetch.current = true;
            getGroupList(null);
        }
    }, [])

    function getGroupList(id: string | null) {
        let getGrpLst = api.adminGroupList;
        if (id) {
            getGrpLst += "/" + id;
        }
        fetch(getGrpLst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((lstResponse) => lstResponse.json())
            .then((lstResult) => {
                if (lstResult.code == 401) {
                    Utils.logoutUser();
                }
                if (id) {
                    // const res = lstResult.data[0];
                    const res = lstResult.data;
                    setGrpName(res.institutionGroupName);
                    setGrpDescription(res.institutionGroupDescription);
                    setUpdateGrpId(res.institutionGroupId)
                }
                else {
                    setGroupList(lstResult.data);
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the institution manager list", error)
            })
    }

    function editGroup(row: { institutionGroupId: string; }) {
        const id = row.institutionGroupId;
        getGroupList(id);
        setIsEdit(true);
        setOpenModal(true)
    }

    function updateGrp() {
        const formData = new FormData();
        formData.append("institutionGroupId", updateGrpId);
        formData.append("institutionGroupName", grpName);
        formData.append("institutionGroupDescription", grpDescription);

        const updategroup = api.UpdateGroup;
        fetch(updategroup, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((updateResponse) => updateResponse.json())
            .then((updateResult) => {
                if (updateResult.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: updateResult.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (updateResult.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: updateResult.message,
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
            .catch((error) => {
                console.log("Failed to update the group", error);
            })
    }

    function addGrp(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateGrp()
            } else {
                const formData = new FormData();
                formData.append("institutionGroupName", grpName);
                formData.append("institutionGroupDescription", grpDescription);

                const addGroup = api.AddGroup;
                fetch(addGroup, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((addResponse) => addResponse.json())
                    .then((addResult) => {
                        if (addResult.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: addResult.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            if (addResult.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: addResult.message,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("Failed to add the group", error);
                    })
            }
        }
    }

    const filteredData = groupList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value.toString().toLowerCase()
        );
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData: { institutionGroupId: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; }) => {
        return <span>{rowData.institutionGroupId}</span>;
    };

    const nameRender = (rowData: { institutionGroupName: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; }) => {
        return <span>{rowData.institutionGroupName}</span>;
    };

    const descriptionRender = (rowData: { institutionGroupDescription: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; }) => {
        return <span>{rowData.institutionGroupDescription}</span>
    }

    const editDetails = (rowData: any) => {
        return (
            <Link to="#" onClick={() => editGroup(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    return (
        <>
            <div className="row">
                <div className="col-sm-12">
                    <div className="court-tab-content">
                        <div className="card card-tableset">
                            <div className="card-body">
                                <div className="coache-head-blk">
                                    <div className="row align-items-center">
                                        {roleId == '1' || roleId == '3' ? (
                                            <>
                                                <div className="row col-md-12">
                                                    <div className="col-md-4">
                                                        <Link
                                                            to="#"
                                                            className="btn btn-secondary"
                                                            onClick={() => { setOpenModal(true); setIsEdit(false); }}>
                                                            <i className="feather-plus" />&nbsp;
                                                            Add Group
                                                        </Link>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                        <div className="col-md-6">
                                        </div>
                                        <div className="col-md-6">
                                            <div className="dataTables_filter">
                                                <label>
                                                    <input
                                                        type="text"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        placeholder="Search"
                                                        className="form-control"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50]}
                                                currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="institutionGroupId"
                                                    body={slNoRender}
                                                    header="Sl No"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="institutionGroupName"
                                                    header="Group Name"
                                                    body={nameRender}
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="institutionGroupDescription"
                                                    header="Description"
                                                    body={descriptionRender}
                                                ></Column>
                                                {(roleId == '1' || roleId == '3') ? (
                                                    <Column
                                                        className="text-link"
                                                        body={editDetails}
                                                    ></Column>
                                                ) : null}
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* add/ edit group */}

            {openModal && (
                <Modal
                    show={openModal}
                    size="md"
                    centered>
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 upper-case"><i className="feather-plus" />{isEdit ? "Edit " : "Add "}Group</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => setOpenModal(false)}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <form ref={formRef}>
                            <div className="mb-10">
                                <label className="form-label">Name</label>
                                <input
                                    id="grpName"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                    value={grpName}
                                    placeholder="Group Name"
                                    required
                                    onChange={(e) => {
                                        setGrpName(e.target.value)
                                    }}
                                />
                            </div>
                            <div className="mb-10">
                                <label className="form-label">Description</label>
                                <textarea
                                    id="grpDesc"
                                    className="form-control"
                                    style={{ border: "1px solid hsl(0, 0%, 80%)" }}
                                    value={grpDescription}
                                    placeholder="Group Description"
                                    required
                                    onChange={(e) => {
                                        setGrpDescription(e.target.value)
                                    }}
                                />
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn-primary text-uppercase"
                            variant="success"
                            onClick={addGrp}
                            data-bs-dismiss="modal" aria-label="Close"
                        >
                            <b><i className="fas fa-save" />{isEdit ? "Update" : "Save"}</b>
                        </Button>
                    </ModalFooter>
                </Modal>
            )}
            {/* /add/ edit group */}

        </>
    );
}

export default GroupList;